import { getRequestData } from '@/utils';
// import { createAccount } from '@/pages/NewConnection/services/billingAccountInfo';
import { emptyObj } from '@/utils';
import { frServiceInfoCheck } from '@/pages/NewConnection/services/selectService';

export default {
  namespace: 'selectService',
  state: {
    certTypeList: [],
    stateAddrOpts: [],
    districtOpts: [],
    mainLocalityOpts: [],
    subLocalityOpts: [],
    custAddrList: [],
    attrObj: {},
    poaDefaultFileList: [],
  },
  effects: {
    * frServiceInfoCheck({ payload }, { call }) {
      const response = yield call(frServiceInfoCheck, payload);
      return getRequestData(response);
    },
    * clear(_, { select, put }) {
      const obj = yield select(state => state.selectService);
      yield put({
        type: 'save',
        payload: { ...emptyObj(obj) },
      });
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
